import { defineMessages } from 'react-intl';

export const messages: {
	authorizeConnectApp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	authorizeConnectApp: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.authorize-connect-app',
		defaultMessage: `Your admin has added <strong>{appName}!</strong>{br}
			Connect your account to see missing results, including documents only you have access to.
		`,
		description:
			'Message explaining that user needs to connect their account to access app content',
	},
	connect: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.connect',
		defaultMessage: 'Connect',
		description: 'Button text to connect to an app',
	},
	notNow: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.not-now',
		defaultMessage: 'Not now',
		description: 'Button text to dismiss the connection popup',
	},
});
